import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// ui
import { Box, ArrowUp, ArrowDown, AbsoluteBox, RelativeFlex } from '../../../ui';
//////////////////////////////////////////////////

const TitleSort = (props) => {
  const { fieldProps, titleSortValue, handleTableTitleFilter } = props;

  const { type, value } = fieldProps;

  const { order, sequence } = titleSortValue;

  const activeColor = 'colors.dark.blue';
  const inactiveColor = 'colors.light.middleGrey';
  const reference = R.equals(type, 'reference');

  return (
    <AbsoluteBox left='100%'>
      <RelativeFlex width={22} height={36} flexDirection='column'>
        {
          G.isNotNil(sequence) &&
          <AbsoluteBox
            top={11}
            left='0'
            width={22}
            fontSize={11}
            fontWeight='bold'
            flexDirection='column'
            color={G.getTheme(activeColor)}
          >
            {sequence}
          </AbsoluteBox>
        }
        <Box
          p='6px'
          cursor='pointer'
          title={GC.SORT_TYPE_ASC}
          onClick={() => handleTableTitleFilter({
            isSorting: true,
            sortData: {
              reference,
              name: value,
              sequence: 1,
              order: GC.SORT_TYPE_ASC,
            },
          })}
        >
          <ArrowUp size={6} color={G.ifElse(R.equals(order, GC.SORT_TYPE_ASC), activeColor, inactiveColor)} />
        </Box>
        <Box
          p='6px'
          cursor='pointer'
          title={GC.SORT_TYPE_DESC}
          onClick={() => handleTableTitleFilter({
            isSorting: true,
            sortData: {
              reference,
              name: value,
              sequence: 1,
              order: GC.SORT_TYPE_DESC,
            },
          })}
        >
          <ArrowDown size={6} color={G.ifElse(R.equals(order, GC.SORT_TYPE_DESC), activeColor, inactiveColor)} />
        </Box>
      </RelativeFlex>
    </AbsoluteBox>
  );
};

export default TitleSort;
